import React, {useState} from 'react'

import './Popup.scss'

// Version of Popup with distinct buttons for onClose vs onComplete.

const ConfirmationPopup = props => {

	// props:
	// data, see below
	// scrim:false turns scrim off. can also be in data
	// centered:false turns off auto centering of popup-body
	// style is style json that gets applied to popup-body
	// instant:true turns off cleanup phase and intro animations


	const [cleanup, setCleanup] = useState(false)

	const data = props.data || {
		scrim:true,
		header:'Error',
		body:"Popup data prop not provided",
		buttonCancel:"cancel",
		buttonConfirm:"confirm"
	}

	const handleButtonCancelClick = () => {
		setCleanup(true);
		setTimeout(()=> {
			if(props.onClose) props.onClose();
		}, (props.instant === true ? 0 : 600))
	
	}

	const handleButtonConfirmClick = () => {
		setCleanup(true);
		setTimeout(()=> {
			if(props.onComplete) props.onComplete();
		}, (props.instant === true ? 0 : 600))
	
	}

	const getAnimationClasses = () => {
		if(props.instant === true) return '';
		return cleanup ? 'cleanup' : 'not-cleanup'
	}

	return (
		<div className={`Popup ${getAnimationClasses()} ${props.class || ''} ${props.centered === false ? 'not-centered' : 'centered'} `}>
			{
				(data.scrim || props.scrim) && 
				<div className="scrim" style={props.style || {}}></div>
			}
			<div className="popup-body" style={props.style || {}}>
				<div className="header" dangerouslySetInnerHTML={{__html:data.header}}></div>
				<div className="body" dangerouslySetInnerHTML={{__html:data.body}}></div>
				<div className="button">
				<div className="global-button" 
					dangerouslySetInnerHTML={{__html:data.buttonCancel}}
					onClick={handleButtonCancelClick}
					></div>
				<div className="global-button" 
					dangerouslySetInnerHTML={{__html:data.buttonConfirm}}
					onClick={handleButtonConfirmClick}
					></div>
				</div>
			</div>
		</div>
	)
}

export default ConfirmationPopup;
